<div
  *ngIf="showValidationMessage"
  class="api-validation-message"
  role="alert"
  aria-live="assertive"
>
  <div class="api-validation-message__icon">
    !
  </div>

  <div class="api-validation-message__content">
    <h6 class="api-validation-message__title">
      {{ title }}
    </h6>

    <p
      *ngIf="mainMessage"
      class="api-validation-message__text"
    >
      {{ mainMessage }}
    </p>

    <ul
      *ngIf="validationMessages.length > 0"
      class="api-validation-message__list"
    >
      <li *ngFor="let validationMessage of validationMessages">
        {{ validationMessage }}
      </li>
    </ul>
  </div>

  <button
    *ngIf="dismissible"
    type="button"
    class="api-validation-message__close"
    aria-label="Close validation message"
    (click)="closeMessage()"
  >
    &times;
  </button>
</div>